// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2vEXz","inputDescription":"styles_inputDescription__3cy4w"};